import Vue from 'vue';

Vue.component('app-wrapper', require('../app/AppWrapper').default);
Vue.component('app-header', require('../app/AppHeader').default);
Vue.component('app-body', require('../app/AppBody').default);